// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox.rolnik_root__3AF0n","isChecked":"Checkbox.rolnik_isChecked__1ii-K","isLink":"Checkbox.rolnik_isLink__n6TX8","label":"Checkbox.rolnik_label__3TgzK"};